enum FundingAccountAddCreditCardFormFieldNames {
    nameOnCard = "funding_account_new_account_add_credit_card_nameOnCard",
    creditCardNumber = "funding_account_new_account_add_credit_card_creditCardNumber",
    expirationDate = "funding_account_new_account_add_credit_card_expirationDate",
    cvc = "funding_account_new_account_add_credit_card_cvc",
    country = "funding_account_new_account_add_credit_card_country",
    postalCode = "funding_account_new_account_add_credit_card_postalCode",
}

export default FundingAccountAddCreditCardFormFieldNames;